window.addEventListener('load', (event) => {

    // Set variables
    var wrapper = document.querySelector("#page-wrapper");
    var drawer = document.querySelector('#mobile-nav-tray');
    var button = document.querySelector('#mobile-nav-btn');
    var windowWidth = document.body.clientWidth;

    // Toggle menu function
    var toggleDrawer = function(){
        wrapper.classList.toggle('active');
        drawer.classList.toggle('active');
        button.classList.toggle('toggled');
        document.documentElement.classList.toggle('no-scroll');   
    }

    if(drawer){

        // Open/close drawer using menu button
        button.addEventListener("click",function(){
            toggleDrawer();
        }, false); 

        // Close drawer when clicking off menu
        wrapper.addEventListener("click",function(){
            if (wrapper.classList.contains('active')) {
                toggleDrawer();
            }
        }, false);

        // Close drawer if window is resized
        window.addEventListener("resize",function(){
            if(document.body.clientWidth !== windowWidth){
                if (wrapper.classList.contains('active')) {
                    toggleDrawer();
                }
            }
            windowWidth = document.body.clientWidth;
        });

    }
});